<div class="labels-dialog">
  <app-popup-top-line></app-popup-top-line>
  <div class="labels-dialog-header">
    <div class="title">{{ inputData.titleLabelPath | labelsProvider }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="labels-dialog-body">
    <app-search-box
      [placeholder]="'labelsDialog.searchLabels' | labelsProvider"
      (textOnSelection)="searchSubmitted($event)"
      [onChangeTriggered]="true"
    ></app-search-box>
    <div class="labels-dialog-body-title">
      {{ 'labelsDialog.systemLabelsTitle' | labelsProvider }}
    </div>
    <div *ngIf="systemLabelsShown.length === 0" class="no-custom-labels">
      {{ 'labelsDialog.noSystemLabelsMsg' | labelsProvider }}
    </div>
    <div *ngFor="let label of systemLabelsShown">
      <app-select-label-dialog
        [label]="label"
        [labelSelected]="isLabelAlreadyBound(label)"
        [editable]="!isLabelAlreadyBound(label)"
        (labelSelectedEventEmitter)="labelSelected($event)"
        (labelUnselectedEventEmitter)="labelUnselected($event)"
        [isCustomLabel]="false"
      ></app-select-label-dialog>
    </div>

    <div class="section-divider"></div>

    <div class="labels-dialog-body-title">
      {{ 'labelsDialog.customLabelsTitle' | labelsProvider }}
    </div>
    <div *ngIf="customLabelsShown.length === 0" class="no-custom-labels">
      {{ 'labelsDialog.noCustomLabelsMsg' | labelsProvider }}
    </div>
    <div class="labels-dialog-body-custom" [ngStyle]="{ height: getCustomLabelHeight() }">
      <div *ngFor="let label of customLabelsShown">
        <app-select-label-dialog
          [label]="label"
          [labelSelected]="isLabelAlreadyBound(label)"
          [editable]="!isLabelAlreadyBound(label)"
          (labelSelectedEventEmitter)="labelSelected($event)"
          (labelUnselectedEventEmitter)="labelUnselected($event)"
          [isCustomLabel]="true"
          [isOperator]="isOperator"
        ></app-select-label-dialog>
      </div>
    </div>

    <div class="labels-dialog-body-title">
      {{ 'labelsDialog.justificationTitle' | labelsProvider }}
    </div>
    <div class="textarea">
      <textarea #noteInput type="text" maxlength="250" placeholder="Content"></textarea>
    </div>
  </div>
  <div class="labels-dialog-footer">
    <button
      class="add"
      cdkFocusInitial
      [ngClass]="{
        'add-disabled': isSelectedLabelsEqualToAlreadyBoundLabels() || isMaxLabelsReached(),
      }"
      (click)="saveLabels(noteInput.value)"
    >
      <span>{{ 'common.save' | labelsProvider }}</span>
    </button>
    <button
      class="create"
      cdkFocusInitial
      (click)="createNewLabelClick()"
      [ngClass]="{ 'create-disabled': !isOperator }"
      [matTooltip]="!isOperator ? 'Only Operators can create labels' : ''"
    >
      <span>{{ 'labelsDialog.createNewLabel' | labelsProvider }}</span>
    </button>
  </div>
</div>
